var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796875 17V15H2.79688V8C2.79688 6.61667 3.21354 5.38733 4.04688 4.312C4.88021 3.23733 5.96354 2.53333 7.29688 2.2V1.5C7.29688 1.08333 7.44287 0.729333 7.73487 0.438C8.02621 0.146 8.38021 0 8.79688 0C9.21354 0 9.56754 0.146 9.85888 0.438C10.1509 0.729333 10.2969 1.08333 10.2969 1.5V2.2C11.6302 2.53333 12.7135 3.23733 13.5469 4.312C14.3802 5.38733 14.7969 6.61667 14.7969 8V15H16.7969V17H0.796875ZM8.79688 20C8.24687 20 7.77621 19.8043 7.38488 19.413C6.99288 19.021 6.79688 18.55 6.79688 18H10.7969C10.7969 18.55 10.6012 19.021 10.2099 19.413C9.81787 19.8043 9.34688 20 8.79688 20ZM4.79688 15H12.7969V8C12.7969 6.9 12.4052 5.95833 11.6219 5.175C10.8385 4.39167 9.89688 4 8.79688 4C7.69688 4 6.75521 4.39167 5.97188 5.175C5.18854 5.95833 4.79688 6.9 4.79688 8V15Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2413640e4f0361b5f5be16246bcd7e77.svg";
export { ForwardRef as ReactComponent };